import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import fetch from 'isomorphic-fetch';
import { setCurrentSection } from '../../actions/globalConfig';
import { checkHttpStatus, parseJSON } from '../../utils';

const propTypes = {
  sectionName: PropTypes.string,
};

const defaultProps = {
  sectionName: 'Photo Galleries',
};

class PhotosView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      galleries: [],
    };
    this.fetchGalleries = this.fetchGalleries.bind(this);
  }

  fetchGalleries() {
    return fetch(`${SERVER_URL}/get_galleries`)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        this.setState({ galleries: response.data });
      })
      .catch((error) => {
        console.log(error, 'An error occurred');
        return Promise.resolve(); // TODO: we need a promise here because of the tests, find a better way
      });
  }

  componentWillMount() {
    this.fetchGalleries();
    this.props.dispatch(setCurrentSection(this.props.sectionName));
  }

  render() {
    const { galleries } = this.state;
    return (
      <div className="container-fluid content faqs-page bg-fff-65 pb-4">
        <div className="row">
          <div className="col-12 text-center pb-4">
            <h1>Photo Galleries</h1>
          </div>
        </div>
        <div className="row">
          {galleries.map((gallery) => (
            <div className="col-6 col-md-4 col-lg-3 mb-3" key={gallery.id}>
              <Link
                to={`/photos/${gallery.slug}`}
                className="gallery-link overflow-hidden position-relative d-block"
                style={{ backgroundImage: `url('${gallery.thumbnail_uri}')`}}
              >
                <span style={{paddingBottom: '75%'}} className="d-block">
                  <span className="gallery-title d-block">
                    {gallery.title}
                  </span>
                </span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

PhotosView.propTypes = propTypes;
PhotosView.defaultProps = defaultProps;

// @todo: maybe pass dispatch action in and make this presentational(?)
export default connect(null)(PhotosView);
